const billerCrossReferenceActionTypes = {
    GET_BILLER_CROSS_REFERENCE_SUCCESS: "GET_BILLER_CROSS_REFERENCE_SUCCESS",
    GET_BILLER_CROSS_REFERENCE_ERROR: "GET_BILLER_CROSS_REFERENCE_ERROR",
};

export default billerCrossReferenceActionTypes;
